// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"bcef9845","727":"9deca930","854":"edb517a5","994":"bcef9845"}[chunkId] + ".chunk.css";
};